<template>
    <div :class="[{ container: !message.reply_message, merchantMessage: message.sent_by_merchant }]">
        <strong v-html="header"></strong>
        <div v-html="body"></div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { makeBold } from '@/components/utils.js'
const props = defineProps({
    message: {
        type: Object,
        default: () => ({}),
        required: true,
    },
});
const header = ref(props.message?.content?.interactive?.header?.text ?? '')
const body = ref(props.message?.content?.interactive?.body?.text ?? '')
onMounted(() => {
    body.value = makeBold(body.value)
})
</script>
<style scoped lang="scss">
@import './styles/interactiveButtons.scss'
</style>
